import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import Nav from './nav';
import List from './list';
import Form from './form';

class Component extends BaseComponent {
    shouldComponentUpdate() {
        return false;
    }

    render({ mode }) {
        return (
            <profiles-manager>
                <Nav />
                <List mode={mode} />
                <Form />
            </profiles-manager>
        );
    }
}

export default connect()(Component);